import { Reason } from '../interfaces'

const timeoutRegExp = RegExp(/time(d )?out/)
const statusCodeRegExp = RegExp(/\b(\d{3})\b/)

export function getReasonFromError(error: Error): Reason {
  let reason: Reason = 'other'
  const message = error.message || error.toString()

  if (message.toLowerCase().includes('response')) {
    return 'invalid_response'
  }

  if (timeoutRegExp.exec(message)) {
    return 'content_timeout'
  }

  const statusCode = (statusCodeRegExp.exec(message) || [])[1]
  if (statusCode?.startsWith('4')) {
    reason = '4xx'
  } else if (statusCode?.startsWith('5')) {
    reason = '5xx'
  }

  return reason
}
